<script setup lang="ts">
import { useUser } from '~/stores/user'

const phiethoc_token = useCookie('phiethoc_client')
const user = useUser()

const isReady = ref(false)

watch(
  phiethoc_token,
  async (value) => {
    if (value) {
      await user.getUserInfo()
    }
    isReady.value = true
  },
  { immediate: true },
)
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtLoadingIndicator color="var(--color-brand)" :height="2" />
  <Body class="font-be-vietnam-pro duration-300 text-black bg-white">
    <ClientOnly>
      <NuxtLayout>
        <NuxtLoadingIndicator />
        <NuxtPage v-if="isReady" />
        <DefaultNotifyPopup />
      </NuxtLayout>
    </ClientOnly>
  </Body>
</template>
